import { Country } from '~shared/models';
import { AccountStatusEnum } from '~shared/constants/account-info.constant';

import { IAccountDetailsSection, IBusinessInfo, IPrivateInfo } from '../models/account-info.model';
import { IConsumerInfoDB, IEntrepreneurInfoDB, UserInfo, UserInfoDB } from '../models/user-info.model';
import {
  ACCOUNT_INFO_SECTIONS,
  AccountInfoSection,
  CONSUMER_ACCOUNT_INFO_SECTION_LIST,
  ENTREPRENEUR_ACCOUNT_INFO_SECTION_LIST,
  METRO_CARD_ACCOUNT_INFO_SECTION_LIST,
} from '../constants/account-info.constant';

export namespace AccountInfoUtil {
  export function transformFromUserToBusinessInfo(accountInfo: UserInfoDB): IBusinessInfo {
    const { email, accountNumber, businessAddress, ...businessInfo } = accountInfo as IEntrepreneurInfoDB;
    return {
      ...businessAddress,
      ...businessInfo,
    };
  }

  export function transformFromUserToPrivateInfo(accountInfo: UserInfoDB): IPrivateInfo {
    const { firstName, lastName } = accountInfo as IConsumerInfoDB;
    return { firstName, lastName };
  }

  export function transformFromBusinessToUserInfo(businessInfo: IBusinessInfo): UserInfo {
    const { street, houseNumber, addressLine2, country, postalCode, city, ...rest } = businessInfo;

    return {
      ...rest,
      businessAddress: {
        street, houseNumber, addressLine2, country, postalCode, city,
      },
    };
  }

  export function generateAccountDetailsList(
    isEntrepreneur: boolean, userInfo: UserInfoDB, countries: Country[],
  ): IAccountDetailsSection[] {
    const sectionList = getAccountDetailsSectionList(isEntrepreneur, userInfo);

    return sectionList.map((sectionName: AccountInfoSection) => {
      const section = {
        ...ACCOUNT_INFO_SECTIONS[sectionName],
      };

      switch(sectionName) {
        case AccountInfoSection.privateInfo:
          section.data = getPrivateInfoData(userInfo);
          break;
        case AccountInfoSection.businessInfo:
          section.data = getBusinessInfoData(userInfo, countries);
          break;
        case AccountInfoSection.cardNumber:
          section.content = (userInfo as IEntrepreneurInfoDB).cardNumber;
          break;
        case AccountInfoSection.email:
          section.content = userInfo.email;
          break;
      }

      return section;
    });
  }

  export function isStatusValidationInProgress(status): boolean {
    return status === AccountStatusEnum.validation;
  }

  export function isStatusValidated(status): boolean {
    return status === AccountStatusEnum.validated;
  }

  function getAccountDetailsSectionList(isEntrepreneur: boolean, userInfo: UserInfoDB) {
    const isMetroCardAccount = (userInfo as IEntrepreneurInfoDB).cardNumber;
    if (isEntrepreneur && isMetroCardAccount) {
      return  METRO_CARD_ACCOUNT_INFO_SECTION_LIST;
    } else if (isEntrepreneur) {
      return ENTREPRENEUR_ACCOUNT_INFO_SECTION_LIST;
    }

    return CONSUMER_ACCOUNT_INFO_SECTION_LIST;
  }

  function getBusinessInfoData(userInfo: UserInfoDB, countries: Array<Country>): IBusinessInfo {
    const businessInfo = transformFromUserToBusinessInfo(userInfo);
    const countryInfo = countries.find(({ id }) => id === businessInfo.country);
    const country = countryInfo && countryInfo.name;

    return {
      ...businessInfo,
      country,
    };
  }

  function getPrivateInfoData({ firstName, lastName }: IConsumerInfoDB): IPrivateInfo {
    return { firstName, lastName };
  }
}
